import { ChevronDown } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AnimatedCollapsible } from "../../../helper/components/AnimatedCollapsible.js";
import { ResetButton } from "../../../helper/components/resetButton/ResetButton.js";
import { useScrollToElement } from "../../../helper/hooks/useScrollToElement.js";
import { useStableId } from "../../../helper/hooks/useStableId.js";
import { Typography } from "../../typography/Typography.js";
import styles from "./StepByStepElement.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SCROLL_OFFSET = -16; // in px

export function StepByStepElement({
  active,
  setActive,
  title,
  titleHtmlTag,
  subtitle,
  content,
  id
}) {
  const targetRef = useRef(null);
  const [clicked, setClicked] = useState(false);
  useEffect(() => {
    // Reset clicked state after element closed
    if (!active) {
      setClicked(false);
    }
  }, [active]);
  const {
    scrollToElement
  } = useScrollToElement(targetRef, SCROLL_OFFSET);
  const onHeightAnimationEnd = useCallback(() => {
    if (active && clicked) {
      scrollToElement();
    }
  }, [active, clicked, scrollToElement]);
  const handleClick = useCallback(() => {
    setClicked(true);
    setActive();
  }, [setActive, setClicked]);
  const buttonId = useStableId();
  const accordionContentId = useStableId();
  const rightContentId = useStableId();
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: classnames(styles.element, active && styles.active),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.left,
      ref: targetRef,
      children: [/*#__PURE__*/_jsxs(ResetButton, {
        id: buttonId,
        className: styles.toggle,
        onClick: handleClick
        // multiple targets should be separated by a space regarding https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-controls
        ,
        "aria-controls": `${accordionContentId} ${rightContentId}`,
        "aria-expanded": active,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          htmlTag: titleHtmlTag,
          margin: false,
          className: styles.title,
          children: title
        }), /*#__PURE__*/_jsx(ChevronDown, {
          className: styles.toggleIcon
        })]
      }), /*#__PURE__*/_jsx("div", {
        id: accordionContentId,
        className: styles.collapsibleWrapper,
        role: "region",
        "aria-labelledby": buttonId,
        "aria-hidden": !active,
        children: /*#__PURE__*/_jsx(AnimatedCollapsible, {
          open: active,
          onHeightAnimationEnd: onHeightAnimationEnd,
          children: /*#__PURE__*/_jsx("div", {
            className: styles.subtitle,
            children: subtitle
          })
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      id: rightContentId,
      className: styles.right,
      role: "region",
      "aria-labelledby": buttonId,
      "aria-hidden": !active,
      children: content
    })]
  });
}